// extracted by mini-css-extract-plugin
module.exports = {"avatars":"_a7b3f3","linkContainer":"_7861f5","inlineBlock":"_2f47c8","authorLink":"_b9678a"};